import { render } from "./QueueCallsTable.vue?vue&type=template&id=604d7f30&ts=true"
import script from "./QueueCallsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueueCallsTable.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/reports/realtime/components/QueueCallsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "604d7f30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('604d7f30', __exports__)) {
    api.reload('604d7f30', __exports__)
  }
  
  module.hot.accept("./QueueCallsTable.vue?vue&type=template&id=604d7f30&ts=true", () => {
    api.rerender('604d7f30', render)
  })

}


export default __exports__